import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AuthForm from "../../Components/Auth_Form/Auth_Form";
import useFetch from "../../utils/useFetch";
import { toast } from "react-toastify";
import { SESSION_EXPIRED_KEY, TOKEN_KEY } from "../../utils/auth";


const AuthPage = () => {
  const navigate = useNavigate();
  const [userCredentials, setUserCredentials] = useState({});
  const { apiData, error, loading } = useFetch(
    "/api/v1/user/login",
    "POST",
    userCredentials,
    true
  );

  const handleSubmit = (data) => {
    setUserCredentials(data);
  };

  // Sent here by an expired or revoked login
  useEffect(() => {
    try {
      if (sessionStorage.getItem(SESSION_EXPIRED_KEY)) {
        sessionStorage.removeItem(SESSION_EXPIRED_KEY);
        toast.info("Your session has ended. Please log in again.");
      }
    } catch {
      // storage unavailable
    }
  }, []);

  useEffect(() => {
    if (apiData && apiData.statusCode === 201) {
      // JWT for every user; each API request sends it (utils/auth.js)
      if (apiData.token) localStorage.setItem(TOKEN_KEY, apiData.token);
      if (apiData.data === "Admin Inframantra") {
        toast.success(`${apiData.message}`);
        localStorage.setItem("username", apiData.data);
        navigate("/dashboard");
      } else {
        toast.success(`${apiData.message}`);
        navigate("/form-selection");
        localStorage.setItem("username", apiData.data);
      }
    } else if (apiData && (apiData.statusCode === 400 || apiData.statusCode === 503)) {
      toast.error(`${apiData.message}`);
    }
  }, [apiData, navigate, loading]);

  localStorage.clear();

  return (
    <div>
      <AuthForm onSubmit={handleSubmit} />
    </div>
  );
};

export default AuthPage;
